import React from 'react'
import { ThemeProvider, createTheme } from '@mui/material/styles'

// changing the palette type in order to allow custom properties
declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      beautifulGradient: string
      solidBeauty: string
      cobaltBlue: string
      backgroundWhisperPurple: string
      attentionRed: string
      redGradient: string
    }
  }

  interface PaletteOptions {
    custom?: {
      beautifulGradient?: string
      solidBeauty?: string
      cobaltBlue?: string
      backgroundWhisperPurple?: string
      attentionRed?: string
      redGradient?: string
    }
  }
}


interface Props {
  children: React.ReactNode
}

// Create your custom theme
const theme = createTheme({
  palette: {
    grey: {
      500: 'rgb(113, 113, 113)' // Change only the standard grey shade
    },
    custom: {
      beautifulGradient: 'linear-gradient(135deg,#7e3f95,#00aeef)',
      solidBeauty: '#7e3f95',
      cobaltBlue: '#295E8A',
      backgroundWhisperPurple: '#faf8fc',
      attentionRed: '#cd3737',
      redGradient: 'linear-gradient(135deg, #cd3737, #ff6b6b)'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.30)' // Custom disabled button text color
          }
        }
      }
    }
  }
})

const MuiCustomThemeProvider: React.FC<Props> = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default MuiCustomThemeProvider
